module.exports = __webpack_public_path__ + "static/media/phylazonit_ng.3454b381.png";